import { OrderHistoryActions } from '../actions/index';
import { OrderHistoryDetails } from '../order-history-state';
import { createReducer, on } from '@ngrx/store';

export const initialState: OrderHistoryDetails = {
    loading: null,
    success: null,
    error: null,
    orderHistoryData: null,
    // tableHeader: [],
    // totalRecords: null
};

export const orderHistoryFetchReducer = createReducer(
    initialState,
    on(OrderHistoryActions.fetchOrderHistory, (state) => ({
        ...state,
        loading: true,
        success: null,
        error: null,
    })),
    on(OrderHistoryActions.fetchOrderHistorySuccess, (state, { orderHistoryData }) => {
        // console.log("payload", orderHistoryData)
        return {
            ...state,
            orderHistoryData,
            loading: null,
            success: true,
            error: null,
        };
    }),
    on(OrderHistoryActions.fetchOrderHistoryFail, (state, { payload }) => ({
        ...state,
        loading: null,
        success: null,
        error: payload
    })),
    on(OrderHistoryActions.clearOrderHistoryState,
        () => ({ ...initialState })
    )
);